import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Row, Col, message, DatePicker, Typography, Spin, Progress } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import { COMMON_ERROR_MSG, SUBMISSION_FAILED } from "../../constants/constants";
import { routes } from "../../routes/Routes";
import PhoneInput from "react-phone-input-auto-format";
import PercentInput from "../../components/PercentInput";
import AlphabetInput from "../../components/AlphabetInput";
import CurrencyInput from "../../components/CurrencyInput";
import ShowApplicationId from "../NewApplication/ShowApplicationId";
import moment from "moment";
import ApplicationProgressBar from "./ApplicationProgressBar";
import { LeftOutlined, RightOutlined, ArrowRightOutlined } from '@ant-design/icons';
import IntegerDecimalInput from "../../components/IntegerDecimalInput";
import "./ApplicantsDetails.scss";
import ButtonComponent from "../../components/Button/Button";

const { Option } = Select;
const { Title } = Typography;

const ApplicantsDetails = () => {
    const [loading, setLoading] = useState(false);
    const [applicanttypes, setApplicanttypes] = useState([]);
    const [applicantInfo, setApplicantInfo] = useState({});
    const history = useHistory();
    const LEGAL_ENTITY_APPLICANT_TYPE_ID = 5;
    const ID = localStorage.getItem("Id");
    const applicationId = localStorage.getItem("ApplicationId");
    const [form] = Form.useForm();
    const selectedApplicantTypeId = Form.useWatch("applicationType", form);
    const isLegalEntitySelected = selectedApplicantTypeId == LEGAL_ENTITY_APPLICANT_TYPE_ID;
    let SponserIdForFirmLogin = localStorage.getItem("SponserIdForFirmLogin");
    const location = useLocation();
    let data = location.state;
    let applnObjId = "";
    let fromDashboard = false;

    if (data && data.applicationObjId) {
        applnObjId = data.applicationObjId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }

    const [appObjId] = useState(applnObjId);
    const [isFromDashboard] = useState(fromDashboard);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        getApplicantTypes();
        // getApplicantDetailsByID();
        // getSponserDataByApplicantEmail();
    }, []);
    // useEffect(() => form.resetFields(), [applicantInfo]);


    let emailId = localStorage.getItem("ApplicationEmailId");

    // const getSponserDataByApplicantEmail = async () => {
    //     try {
    //       const res = await _NewapplicationService.getSponserDataByApplicantEmail(emailId);
    //       const data = res.data;
    //       if (data?.IsSuccess && data?.Obj) {
    //         const sponsor = data.Obj;
    //         form.setFieldsValue({
    //             loanAmount: sponsor.ProspectiveGPCommitmentAmount,
    //         });
    //       } else {
    //         message.warning("Sponsor data not found");
    //       }
    //     } catch (error) {
    //       console.error("Error fetching sponsor data:", error);
    //       message.error("Failed to fetch sponsor data");
    //     }
    //   };

    useEffect(() => {
        fetchFormData();
    }, []);

    const fetchFormData = async () => {
        try {
            setLoading(true);

            const [applicantRes, sponsorRes] = await Promise.all([
                _NewapplicationService.getApplicantInformationByApplicationId(isFromDashboard ? applnObjId : ID),
                _NewapplicationService.getSponserDataByApplicantEmail(emailId, SponserIdForFirmLogin),
            ]);

            if (applicantRes?.data) {
                const app = applicantRes.data;
                setApplicantInfo({ ...app });
                form.setFieldsValue({
                    applicationType: app.App_Det_Application_Type_Id,
                    firstName: app.App_Det_FirstName,
                    middleInitial: app.App_Det_MiddleInitial,
                    lastName: app.App_Det_LastName,
                    dob: app.App_Det_DateOfBirth ? moment(app.App_Det_DateOfBirth) : null,
                    contactNumber: app.App_Det_ContactNumber || "",
                    loanAmount: app.App_Det_FirstName ? app.App_Det_LoanAmount : sponsorRes.data.Obj.ProspectiveGPCommitmentAmount, // will be overwritten below if sponsor data exists
                    interestExpense: app.App_Det_InterestExpense,
                    projectedAnnualIntExp: app.App_Det_FullyLoadedProjectedAnnualInterestExpense,
                    legalEntityName: app.Legal_EntityName,
                    legalEntityType: app.Legal_Entity_Type,
                    legalEinTin: app.Legal_EIN_TIN,
                    legalPrincipalBusinessAddress: app.Legal_Principal_Business_Address,
                    legalStateCountryFormation: app.Legal_State_Country_Formation,
                    legalDateFormed: app.Legal_DateFormed ? moment(app.Legal_DateFormed) : null,
                });
            }

            if (sponsorRes?.data?.IsSuccess && sponsorRes.data.Obj) {
                const app = applicantRes && applicantRes.data;
                const sponsor = sponsorRes.data.Obj;
                form.setFieldsValue({
                    loanAmount: app.App_Det_FirstName ? app.App_Det_LoanAmount : sponsor.ProspectiveGPCommitmentAmount,
                    interestExpense: sponsor.IntrestExpense,
                    projectedAnnualIntExp: app.App_Det_FirstName ? app.App_Det_FullyLoadedProjectedAnnualInterestExpense : sponsor.ProjectedAnnualInterestExpense,
                    ...(!app.App_Det_FirstName && {
                        firstName: sponsor.ApplicantName,
                        middleInitial: sponsor.ApplicantMiddleName,
                        lastName: sponsor.ApplicantLastName,
                        contactNumber: sponsor.ApplicantPhone || "",
                    }),
                });
            }

        } catch (error) {
            console.error("Error loading form data", error);
            message.error("Something went wrong while loading data");
        } finally {
            setLoading(false);
        }
    };


    const onFinish = async (values) => {
        const selectedApplicationType = applicanttypes.find(
            (type) => type.Id === values.applicationType
        );
        const applicationType = selectedApplicationType.Name?.toLowerCase();
        const applicationTypeId = selectedApplicationType.Id;
        const midadleFirstLetter = values.middleInitial || "";

        const dob = values.dob?.format("YYYY-MM-DD");
        const legalDateFormed = values.legalDateFormed?.format("YYYY-MM-DD");

        setLoading(true);
        let reqObj = {
            Id: ID,
            ScreenName: "aapplicationdetails",
            ApplicationId: localStorage.getItem("ApplicationId"),
            App_Det_Application_Type_Id: values.applicationType,
            App_Det_FirstName: values.firstName,
            App_Det_MiddleInitial: midadleFirstLetter,
            App_Det_LastName: values.lastName,
            App_Det_DateOfBirth: dob,
            App_Det_ContactNumber: values.contactNumber,
            App_Det_LoanAmount: values.loanAmount,
            App_Det_InterestExpense: values.interestExpense,
            App_Det_FullyLoadedProjectedAnnualInterestExpense: values.projectedAnnualIntExp,
            IsAapplicationDetailsCompleted: true,
        }

        if (isLegalEntitySelected) {
            reqObj.Legal_EntityName = values.legalEntityName;
            reqObj.Legal_Entity_Type = values.legalEntityType;
            reqObj.Legal_EIN_TIN = values.legalEinTin;
            reqObj.Legal_Principal_Business_Address = values.legalPrincipalBusinessAddress;
            reqObj.Legal_State_Country_Formation = values.legalStateCountryFormation;
            reqObj.Legal_DateFormed = legalDateFormed;
        }
        try {
            const res = await _NewapplicationService.submitApplicantData(reqObj);

            if (res.data.IsSuccess) {
                localStorage.setItem("applicationTypeId", applicationTypeId);
                localStorage.setItem("ApplicationStatusId", applicantInfo && applicantInfo.Application_Status_Id);
                setLoading(false);
                message.success(res.data.Message);
                console.log("applicationType", applicationType)
                if (!isFromDashboard) {
                    if (applicationTypeId == 1) {
                        history.push({ pathname: routes.applicantsIdentification.path });
                    } else if (applicationTypeId == 2) {
                        history.push({ pathname: routes.ProofOfTrust.path });
                    } else if (applicationTypeId == 3) {
                        history.push({ pathname: routes.ProofOfTrust.path });
                    } else if (applicationTypeId == 4) {
                        history.push({ pathname: routes.applicantsIdentification.path });
                    } else if (applicationTypeId == 5) {
                        history.push({ pathname: routes.uploaddocuments.path });
                    } else {
                        console.log("");
                    }
                } else {
                    history.push({ pathname: routes.dashboard.path, state: applnObjId });
                }
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
        finally {
            setLoading(false);
        }

    };

    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.dashboard.path, state: applnObjId });
        } else if (localStorage.getItem("isFromMyApplicationsList") == "true") {
            history.push({ pathname: routes.myApplications.path });
        }
    }

    const getApplicantTypes = async () => {
        try {
            const res = await _NewapplicationService.getAllDropdownDataByName("applicanttypes");
            if (res.data) {
                setApplicanttypes(res.data);
            }
        } catch (e) {
            console.log(e);

        }
    };

    // const getApplicantDetailsByID = async () => {
    //     try {
    //         setLoading(true);
    //         const res = await _NewapplicationService.getApplicantInformationByApplicationId(isFromDashboard ? applnObjId : ID);
    //         console.log("ab res", res)
    //         if (res.data) {
    //             let resObj = res?.data;

    //             setApplicantInfo({
    //                 applicationType: resObj.App_Det_Application_Type_Id,
    //                 firstName: resObj.App_Det_FirstName,
    //                 middleInitial: resObj.App_Det_MiddleInitial,
    //                 lastName: resObj.App_Det_LastName,
    //                 dob: resObj.App_Det_DateOfBirth ? moment(resObj.App_Det_DateOfBirth) : null,
    //                 contactNumber: resObj.App_Det_ContactNumber,
    //                 loanAmount: resObj.App_Det_LoanAmount,

    //             });

    //             setLoading(false);
    //         }
    //     } catch (e) {
    //         setLoading(false);
    //         console.log(e);
    //     }
    // };

    const disableFutureDates = (current) => {
        return current && current > moment().endOf("day");
    };

    const onValuesChange = (changedValues, allValues) => {
        const fieldName = Object.keys(changedValues)[0];

        if (["loanAmount", "interestExpense"].includes(fieldName)) {
            const loanAmount = parseFloat(allValues.loanAmount);
            const interestExpense = parseFloat(allValues.interestExpense);

            if (!isNaN(loanAmount) && !isNaN(interestExpense)) {
                let result = (loanAmount * interestExpense) / 100;

                // Check if result is an integer
                const isInt = Number.isInteger(result);

                const displayValue = isInt
                    ? result.toString()
                    : result.toFixed(2);

                form.setFieldsValue({
                    projectedAnnualIntExp: displayValue
                });
            } else {
                form.setFieldsValue({
                    projectedAnnualIntExp: ""
                });
            }
        }
    };

    return (
        <Spin spinning={loading}>
            <LeftLayout>

                {/* {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                <div style={{
                    position: "absolute",
                    top: 5,
                    right: 20,
                    margin: 0,
                    zIndex: 1000,
                    maxWidth: "1000px",
                    padding: "8px 16px",
                }}>
                    <ApplicationProgressBar />
                    <Title level={3} style={{ margin: 0 }}>
                        <ShowApplicationId />
                    </Title>
                </div>
            )} */}

                <div>
                    {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                        <div>
                            <ApplicationProgressBar />
                            <Title level={5}>
                                {/* <ShowApplicationId /> */}
                            </Title>
                        </div>
                    )}
                </div>


                <div className="application-dark-page">
                    <div className="application-card">

                        <Row>
                            <Col span={24}>
                                <Title level={3} className="page-title">Personal Details</Title>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onFinish}
                                    // initialValues={applicantInfo}
                                    onValuesChange={onValuesChange}
                                >


                                    <Row gutter={16}>
                                        <Col xs={24} md={12} >
                                            <Form.Item
                                                label="First Name"
                                                name={"firstName"}
                                                rules={[{ required: true, message: "First Name is required" }]}
                                            >
                                                <AlphabetInput placeholder="Enter First Name" maxLength={30} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Form.Item
                                                label="Middle Name"
                                                name="middleInitial"
                                                // rules={[
                                                //     { required: false, max: 1, message: "Only one character allowed" },
                                                // ]}
                                            >
                                                <AlphabetInput placeholder="Enter Middle Name" maxLength={30} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Form.Item
                                                label="Last Name"
                                                name="lastName"
                                                rules={[{ required: true, message: "Last Name is required" }]}
                                            >
                                                <AlphabetInput placeholder="Enter Last Name" maxLength={30} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Form.Item
                                                label="Application Type"
                                                name="applicationType"
                                                rules={[{ required: true, message: "Application Type is required" }]}

                                            >
                                                <Select
                                                    placeholder="Select"
                                                    disabled={applicantInfo && applicantInfo.App_Det_FirstName == null ? false : true}
                                                >
                                                    {applicanttypes.map((obj) => (
                                                        <Option key={obj.Id} value={obj.Id}>
                                                            {obj.Name}
                                                        </Option>
                                                    ))}

                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={12}>
                                            <Form.Item
                                                label="Date Of Birth"
                                                name="dob"

                                                rules={[{ required: true, message: "Date Of Birth is required" }]}
                                            >
                                                <DatePicker
                                                    style={{ width: "100%" }}
                                                    format="MM/DD/YYYY"
                                                    disabledDate={(current) => {
                                                        return current && current >= moment().startOf("day");
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={12}>
                                            <Form.Item
                                                label="Contact Number"
                                                name="contactNumber"

                                                rules={[
                                                    { required: true, message: "Contact Number is required" },
                                                    {
                                                        validator: (_, value) => {
                                                            if (!value) {
                                                                return Promise.resolve(); //  Allow empty value if not required
                                                            }
                                                            const digits = value.replace(/\D/g, '');
                                                            if (digits.length === 10) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(
                                                                new Error("Wrong format! please use this format (XXX) XXX-XXXX")
                                                            );
                                                        },
                                                    }
                                                ]}
                                            >
                                                <PhoneInput
                                                    placeholder="Enter Contact Number"
                                                    inputComponent={Input}
                                                    autoComplete="off"
                                                    onChange={(value) => {
                                                        // Remove non-digit characters and store the raw number
                                                        const digits = value.replace(/\D/g, '');
                                                        form.setFieldsValue({ contactNumber: digits });
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    {isLegalEntitySelected && (
                                        <div className='LoanProgramborderBox' style={{ marginBottom: "20px" }}>
                                            <Title level={5} className="sub-title">Legal Entity Information</Title>

                                            <Row gutter={16}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        label="Legal Entity Name"
                                                        name="legalEntityName"
                                                        rules={[{ required: isLegalEntitySelected, message: "Legal Entity Name is required" }]}
                                                    >
                                                        <Input placeholder="Enter Legal Entity Name" maxLength={100} />
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        label="Entity Type"
                                                        name="legalEntityType"
                                                        rules={[{ required: isLegalEntitySelected, message: "Entity Type is required" }]}
                                                    >
                                                        <Select placeholder="Select Entity Type">
                                                            <Option value="LLC">LLC</Option>
                                                            <Option value="LP">LP</Option>
                                                            <Option value="Corp">Corp</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        label="EIN / TIN"
                                                        name="legalEinTin"
                                                        rules={[{ required: isLegalEntitySelected, message: "EIN / TIN is required" }]}
                                                    >
                                                        <Input placeholder="Enter EIN / TIN" maxLength={20} />
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        label="Principal Business Address"
                                                        name="legalPrincipalBusinessAddress"
                                                        rules={[{ required: isLegalEntitySelected, message: "Principal Business Address is required" }]}
                                                    >
                                                        <Input placeholder="Enter Principal Business Address" maxLength={200} />
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        label="State / Country of Formation"
                                                        name="legalStateCountryFormation"
                                                        rules={[{ required: isLegalEntitySelected, message: "State / Country of Formation is required" }]}
                                                    >
                                                        <Input placeholder="Enter State / Country of Formation" maxLength={100} />
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        label="Date Formed"
                                                        name="legalDateFormed"
                                                        rules={[{ required: isLegalEntitySelected, message: "Date Formed is required" }]}
                                                    >
                                                        <DatePicker
                                                            style={{ width: "100%" }}
                                                            format="MM/DD/YYYY"
                                                            disabledDate={disableFutureDates}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    )}

                                    <div className='LoanProgramborderBox'>
                                        <Title level={5} className="sub-title">Loan Program Details</Title>

                                        <Row gutter={16}>
                                            <Col xs={24} md={8}>
                                                <Form.Item
                                                    label="Requested Loan Amount $"
                                                    name="loanAmount"

                                                    rules={[
                                                        { required: true, message: "Requested Loan Amount is required" },
                                                        {
                                                            pattern: /^\d+(\.\d{1,2})?$/,
                                                            message: "Enter a valid amount",
                                                        },
                                                    ]}
                                                >
                                                    <CurrencyInput
                                                        placeholder="Enter Requested Loan Amount"
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} md={8}>
                                                <Form.Item
                                                    label="Interest Expense %"
                                                    name="interestExpense"

                                                    rules={[
                                                        // { required: true, message: "Interest Expense is required" },
                                                        {
                                                            pattern: /^\d+(\.\d{1,2})?$/,
                                                            message: "Enter a valid amount",
                                                        },]}
                                                >
                                                    <IntegerDecimalInput
                                                        placeholder="Enter Interest Expense"
                                                        maxLength={5}
                                                        disabled

                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} md={8}>
                                                <Form.Item
                                                    label="Projected Annual Interest Expense $"
                                                    name="projectedAnnualIntExp"
                                                    rules={[
                                                        { required: false, message: "Projected Annual Interest Expense is required" },
                                                        {
                                                            pattern: /^\d+(\.\d{1,2})?$/,
                                                            message: "Enter a valid amount",
                                                        },
                                                    ]}

                                                >
                                                    <CurrencyInput
                                                        placeholder="Enter Projected Annual Interest Expense"
                                                        disabled

                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </div>

                                    <Form.Item className="rightsection">
                                        <div className="buttoncss">
                                            {/* {(isFromDashboard || localStorage.getItem("isFromMyApplicationsList") == "true") &&
                                             <ButtonComponent 
                                            type="default"
                                            onClick={onBack}
                                            text="Go Back"
                                        />
                                        } */}
                                            <ButtonComponent
                                                text={
                                                    <span>
                                                        Save And Proceed <ArrowRightOutlined />
                                                    </span>
                                                }
                                                type="primary"
                                                htmlType="submit"
                                                disabled={[1, 2, 4, 9].includes(applicantInfo && applicantInfo.Application_Status_Id) ? false : true}

                                            />

                                            {/* <Button
                                            type="primary"
                                            htmlType="submit"
                                            disabled={![1,2,4,9].includes(applicantInfo && applicantInfo.Application_Status_Id) ? true : false}
                                        >
                                            Save And Proceed <RightOutlined />
                                        </Button> */}
                                        </div>
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                </div>
            </LeftLayout>
        </Spin>
    );
};

export default ApplicantsDetails;